import { useEffect, useRef } from 'react';

/**
 * Track the mounted state of the component.
 */
export const useMounted = () => {
  const mounted = useRef(false);

  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);

  return mounted;
};
